import type { AppSelectOption } from './app-select'

/**
 * Infobulle du déclencheur (`valueTitle`) : libellé de l'option choisie. Sans choix (`null`), rien,
 * même si une option porte `null` : le placeholder est déjà lisible en entier.
 */
export const valueTitleOf = <TValue>(
  options: readonly AppSelectOption<TValue>[],
  value: TValue | null,
): string | undefined =>
  value === null ? undefined : options.find((option) => Object.is(option.value, value))?.label
